import { useEffect, useRef, useState } from "react";
import Checkbox from "react-custom-checkbox";
import * as Icon from "react-icons/fi";
import { FaCheck } from "react-icons/fa";
import { MdDelete } from "react-icons/md";

import POService from "src/Services/API/po.service";
import OutsideClickHandler from "react-outside-click-handler/build/OutsideClickHandler";
import { toast } from "react-toastify";
import { getImageUrl, getRealFileName } from "src/Common/common";
import { handleError } from "src/Common/function";
import WhiteUploadButton from "src/Components/Common/whiteuploadbutton";
import UserService from "src/Services/API/user.service";
import VendorService from "src/Services/API/vendor.service";
import WOService from "src/Services/API/wo.service";
import VendorDropDown from "../dropdown/vendordropdown";
import PaymentDropdown from "./PaymentDropdown";
import { alertTitleClasses } from "@mui/material";
import TechDropDown from "src/Components/filter/components/TechDropdown";
import ConfirmDialog from "src/Common/confirmdialog";

function CreatePoModal({ shown, onCancelClicked, onSubmitClicked, wo, editingPO }) {
  const currentUser = UserService.getCurrentUser();
  const [vendorList, setVendorList] = useState([]);
  //
  const [woNumber, setWONumber] = useState(wo.number);
  const [po, setPo] = useState(null);
  // const [poNumber, setPoNumber] = useState(null);
  const [vendor, setVendor] = useState("");
  const [paymentType, setPaymentType] = useState(-1);
  const [description, setDescription] = useState("");
  const [note, setNote] = useState("");
  const [items, setItems] = useState([]);
  const [itemIndex, setItemIndex] = useState(0);
  const itemInputFile = useRef(null);
  const receiptInputFile = useRef(null);

  const [techArray, setTechArray] = useState([]);
  const [issuedUser, setIssuedUser] = useState(null);
  const [receipts, setReceipts] = useState([]);
  const [isUploadingReceipt, setIsUploadingReceipt] = useState(false);
  const [isReceiptDragActive, setIsReceiptDragActive] = useState(false);
  const receiptDragCounter = useRef(0);

  const [cancelled, setCancelled] = useState(false);
  const [cancelConfirmation, setCancelConfirmation] = useState(false);

  //uploading attachment

  useEffect(() => {
    if (shown) {
      setVendorList([]);
      VendorService.getAll("")
        .then((response) => {
          if (response.status == 200) {
            setTimeout(() => {
              setVendorList(response.data.map((obj) => obj.name));
            }, 1000);
          }
        })
        .catch((error) => {
          console.log("Fetching Vendor List Error: ", error);
        });

      setTechArray([]);
      // UserService.getUsersByRole("Technician", wo.branch)
      //   .then((response) => {
      //     console.log("Tech response: ", response.data);
      //     if (response.status == 200) {
      //       setTechArray(response.data);
      //     }
      //   })
      //   .catch((error) => {
      //     console.log("tech fetching error: ", error);
      //   });

      UserService.getUsersByRoleWithBranchId("Technician", wo.branch?.id)
        .then((response) => {
          if (response.status == 200) {
            let techs = response.data.filter((user) => user.isEnabled === true);
            UserService.getUsersByRoleWithBranchId("Manager", wo.branch?.id)
              .then((res) => {
                if (res.status == 200) {
                  let managers = res.data.filter((user) => user.isEnabled === true);
                  UserService.getUsersByRoleWithBranchId("Project Manager", wo.branch?.id)
                    .then((pmRes) => {
                      if (pmRes.status == 200) {
                        let projectManagers = pmRes.data.filter((user) => user.isEnabled === true);
                        setTechArray([...techs, ...managers, ...projectManagers].sort((a, b) => a.name.localeCompare(b.name)));
                      }
                    })
                    .catch((error) => handleError(error));
                }
              })
              .catch((error) => handleError(error));
          }
        })
        .catch((error) => handleError(error));
    }
  }, [shown, vendor]);

  useEffect(() => {
    if (editingPO && shown) {
      console.log("Editing po: ", po);
      setPo(editingPO);
      // setPoNumber(editingPO.number);
      setDescription(editingPO.description);
      setNote(editingPO.note);
      setVendor(editingPO.vendor);
      setPaymentType(editingPO.paymentType);
      setIssuedUser(editingPO.issuedUser || null);
      setReceipts([]);
    } else {
      setItems([]);
      // setPoNumber("");
      setDescription("");
      setVendor("");
      setIssuedUser(null);
      setReceipts([]);
    }
  }, [shown]);

  const submitClicked = async () => {
    let data;
    if (editingPO) {
      let response;
      try {
        response = await WOService.getWorkOrderByNumber(woNumber);
        if (response.data.length === 0) {
          toast("Invalid Work Order Number");
          return;
        }
      } catch (error) {
        handleError(error);
        return;
      }

      data = {
        id: po.id,
        data: {
          wo: response.data.id,
          // number: poNumber,
          vendor: vendor,
          description: description,
          note: note,
          paymentType: paymentType,
          issuedUser: issuedUser,
          // receipts: receipts.filter((obj) => obj.base64),
        },
        eventUser: currentUser,
      };
    } else {
      let filtered = items.filter((item) => item.description.length > 0);

      data = {
        po: {
          wo: wo.id,
          // number: poNumber,
          vendor: vendor,
          description: description,
          note: note,
          paymentType: paymentType,
          requestedUser: UserService.getCurrentUser().id,
          issuedUser: issuedUser,
          issuedBy: UserService.getCurrentUser().id,
          issuedDate: new Date(),
          status: 2,
          receipts: receipts,
        },
        items: filtered,
        eventUser: currentUser,
      };
    }

    console.log("data: ", data);
    onSubmitClicked(data);
  };

  const paymentTypeClicked = (index) => {
    setPaymentType(index);
  };

  const addItem = () => {
    setItems([...items, { description: "", base64: "", name: "" }]);
  };

  const uploadClicked = (index) => {
    itemInputFile.current.click();
    setItemIndex(index);
  };

  const descriptionChanged = (e, index) => {
    const newText = e.target.value;
    let temp = [...items];
    temp[index].description = newText;
    setItems(temp);
  };

  const vendorSelected = (option) => {
    console.log("selected vendor: ", option);
    setVendor(option);
  };

  const uploadReceipt = () => {
    receiptInputFile.current.click();
  };

  const resetReceiptDragState = () => {
    receiptDragCounter.current = 0;
    setIsReceiptDragActive(false);
  };

  const handleReceiptFiles = (files) => {
    if (files.length === 0 || editingPO) {
      return;
    }

    setIsUploadingReceipt(true);
    const validFiles = files.filter((file) => file.size <= 5242880);
    const invalidFiles = files.filter((file) => file.size > 5242880);

    if (invalidFiles.length > 0) {
      toast("Each file size cannot exceed more than 5MB");
    }

    if (validFiles.length > 0) {
      setReceipts((prev) => [
        ...prev,
        ...validFiles.map((file) => ({ name: file.name, type: file.type, file })),
      ]);
    }

    setIsUploadingReceipt(false);
  };

  const receiptSelected = (e) => {
    const files = Array.from(e.target.files || []);
    handleReceiptFiles(files);
    e.target.value = "";
  };

  const handleReceiptDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (editingPO || isUploadingReceipt) return;

    receiptDragCounter.current += 1;
    setIsReceiptDragActive(true);
  };

  const handleReceiptDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (editingPO || isUploadingReceipt) return;

    setIsReceiptDragActive(true);
  };

  const handleReceiptDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (editingPO || isUploadingReceipt) return;

    receiptDragCounter.current = Math.max(receiptDragCounter.current - 1, 0);
    if (receiptDragCounter.current === 0) {
      setIsReceiptDragActive(false);
    }
  };

  const handleReceiptDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (editingPO || isUploadingReceipt) return;

    const files = Array.from(e.dataTransfer.files || []);
    resetReceiptDragState();
    handleReceiptFiles(files);
  };

  const removeReceipt = (indexToRemove) => {
    setReceipts((prev) => prev.filter((_, index) => index !== indexToRemove));
  };

  const fileSelected = (e) => {
    const file = e.target.files[0];
    if (file.size > 5242880) {
      toast("File size cannot exceed more than 5MB");
      return;
    }

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64 = reader.result.split(",")[1];
        let temp = [...items];
        temp[itemIndex].base64 = base64;
        temp[itemIndex].name = file.name;
        temp[itemIndex].type = file.type;
        setItems(temp);
      };
      reader.readAsDataURL(file);
    }
  };

  const techSelected = (index) => {
    setIssuedUser(techArray[index]);
  };

  return (
    shown && (
      <div className="fixed w-screen h-screen left-0 top-0 bg-black bg-opacity-30 flex items-center justify-center z-30">
        <ConfirmDialog
          title="Cancel Purchase Order"
          description="Are you sure you want to cancel this purchase order?"
          shown={cancelConfirmation}
          onConfirmClicked={() => onCancelClicked()}
          onCancelClicked={() => setCancelConfirmation(false)}
        />

        <OutsideClickHandler onOutsideClick={() => !cancelConfirmation && onCancelClicked()}>
          <div className="w-[436px] bg-white rounded-[6px] p-[18px] flex flex-col relative">
            {/* upload button */}
            <div className="absolute flex flex-col top-[20px] right-[18px]">
              <input
                onChange={(e) => fileSelected(e)}
                type="file"
                id="file"
                ref={itemInputFile}
                style={{ display: "none" }}
                multiple={false}
                accept="image/*,application/pdf"
              />
              <input
                onChange={receiptSelected}
                type="file"
                id="receiptfile"
                ref={receiptInputFile}
                style={{ display: "none" }}
                multiple={true}
                accept="image/*,application/pdf"
              />
            </div>
            {editingPO ? (
              <p className="text-[16px] text-center font-OpenSansMedium font-[600] text-titleColor mb-2">
                EDIT A PURCHASE ORDER
              </p>
            ) : (
              <p className="text-[16px] text-center font-OpenSansMedium font-[600] text-titleColor mb-2">
                CREATE A PURCHASE ORDER
              </p>
            )}
            <div className="flex flex-col mt-4">
              <div className="w-full ">
                <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-2">WO#</p>
                <input
                  value={woNumber}
                  type="text"
                  onChange={(e) => setWONumber(e.target.value)}
                  className="w-full border-solid border-[1px] rounded-[5px] text-inputEmailTitle text-[11px] font-[400] font-OpenSansMedium px-2 py-1"
                  placeholder="Enter WO #"
                />
              </div>
              <div className="z-20 mt-4">
                <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-2">Payment Type</p>
                <PaymentDropdown itemClicked={paymentTypeClicked} defaultValue={paymentType} />
              </div>
              <div className="w-full mt-4">
                <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-2">Vendor</p>
                <VendorDropDown options={vendorList} defaultOption={vendor} onSelect={vendorSelected} />
              </div>
              <div className="w-full mt-4">
                <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-2">Description</p>
                <textarea
                  value={description}
                  type="text"
                  onChange={(e) => setDescription(e.target.value)}
                  multiple={true}
                  className="w-full h-[70px] border-solid border-[1px] rounded-[5px] text-inputEmailTitle text-[11px] font-[400] font-OpenSansMedium px-2 py-1"
                  placeholder="Enter Description"
                />
              </div>

              <div className="flex gap-2 mt-4 items-center">
                <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor">Issued For: </p>
                <div className="flex-auto">
                  <TechDropDown options={techArray} selectedTech={issuedUser} onSelect={techSelected} />
                </div>
              </div>

              <div className="w-full mt-4">
                <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-2">Note</p>
                <textarea
                  value={note}
                  type="text"
                  onChange={(e) => setNote(e.target.value)}
                  multiple={true}
                  className="w-full h-[70px] border-solid border-[1px] rounded-[5px] text-inputEmailTitle text-[11px] font-[400] font-OpenSansMedium px-2 py-1"
                  placeholder="Enter Note"
                />
              </div>

              {!editingPO && (
                <div className="w-full mt-4">
                  <div className="flex items-center justify-between gap-3">
                    <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor">Attachments</p>
                    <WhiteUploadButton isLoading={isUploadingReceipt} clicked={uploadReceipt} />
                  </div>
                  <div
                    className={`mt-2 rounded-[6px] border border-dashed p-3 transition-colors ${isReceiptDragActive ? "border-blueColor bg-[#F4F8FF]" : "border-borderColor"}`}
                    onDragEnter={handleReceiptDragEnter}
                    onDragOver={handleReceiptDragOver}
                    onDragLeave={handleReceiptDragLeave}
                    onDrop={handleReceiptDrop}
                  >
                    {receipts.length > 0 ? (
                      <div className="max-h-[70px] overflow-y-auto flex flex-col gap-2">
                        {receipts.map((attachment, index) => (
                          <div key={`${attachment.name}-${index}`} className="flex items-start justify-between gap-3">
                            <span className="flex-1 font-OpenSansRegular font-[400] text-[11px] text-titleColor break-all">
                              {attachment.name}
                            </span>
                            <button
                              type="button"
                              onClick={() => removeReceipt(index)}
                              className="shrink-0 cursor-pointer"
                            >
                              <MdDelete color="#010D3D" size={16} />
                            </button>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <p className="font-OpenSansRegular text-[11px] text-subTitleColor">
                        No attachments added yet.
                      </p>
                    )}
                    <p className="mt-2 font-OpenSansRegular text-[10px] text-subTitleColor">
                      Drag and drop files here, or click upload.
                    </p>
                  </div>
                </div>
              )}

              {/* Don't delete this section, it's for future use */}

              {!editingPO && (
                <div className="w-full mt-4">
                  <div className="flex items-center justify-between">
                    <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-2">Item List</p>
                    <p
                      onClick={addItem}
                      className="text-subTitleColor text-[11px] font-OpenSansMedium font-[400] cursor-pointer"
                    >
                      + ADD
                    </p>
                  </div>
                  <div className="flex items-center justify-between">
                    <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor">Item Description</p>
                    <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor">Attachment</p>
                  </div>
                  <div className="flex flex-col h-[70px] overflow-auto">
                    {items.map((item, index) => {
                      return (
                        <div key={index} className="flex items-center justify-between gap-2 mb-2">
                          <input
                            onChange={(e) => descriptionChanged(e, index)}
                            className="border-solid border-[1px] border-borderColor rounded-[6px] flex-1 ont-OpenSansRegular font-[600] text-[11px] h-[30px] px-2"
                          />
                          {item.name.length === 0 ? (
                            <div
                              onClick={() => uploadClicked(index)}
                              className="rounded-[6px] w-[150px] h-[30px] flex items-center justify-center gap-1 cursor-pointer border-solid border-borderColor border-[1px]"
                            >
                              <img src={getImageUrl("/images/common/upload_black.png")} />
                              <span className="font-OpenSansRegular font-[600] text-[10px] text-[#404A6E]">UPLOAD</span>
                            </div>
                          ) : (
                            <span className="font-OpenSansRegular font-[400] text-[10px] text-[#404A6E]">
                              {item.name}
                            </span>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
            <div className="w-full mt-4">
              <div className="flex items-center justify-between gap-4">
                <div
                  onClick={onCancelClicked}
                  className="w-[50%] h-[30px] text-[10px] rounded-[6px] border-[1px] border-subTitleColor flex items-center justify-center text-subTitleColor cursor-pointer"
                >
                  CANCEL
                </div>
                <div
                  onClick={submitClicked}
                  className="w-[50%] h-[30px] text-[10px] rounded-[6px] flex items-center justify-center bg-blueColor text-white cursor-pointer"
                >
                  SUBMIT
                </div>
              </div>
            </div>
          </div>
        </OutsideClickHandler>
      </div>
    )
  );
}

export default CreatePoModal;
